// removed by extract-text-webpack-plugin
module.exports = {"button":"CollapseButton-module__button___1u0fa","mobile":"CollapseButton-module__mobile___3igCZ","button-icon":"CollapseButton-module__button-icon___hisaM","icon":"CollapseButton-module__icon___imUYy","button-title":"CollapseButton-module__button-title___FkgWZ"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/CarrierMessages/CollapseButton/CollapseButton.module.scss
// module id = 312
// module chunks = 0 1